import { useSnackbars } from '../../../../hooks/snackbar.hook';
import React, { useState } from 'react';
import DirectDebitForm from '../../../../components/forms/direct-debit/direct-debit.form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { DirectDebitFormDto } from '../../../../services/dtos/form/direct-debit-form.dto';
import { createDirectDebit, changeDirectDebit } from '../../../../services/requests.service';
import { AxiosError } from 'axios';
import { showAxiosMessageError } from '../../../../services/error-message.service';
import { DirectDebitDto } from '../../../../services/dtos/direct-debit.dto';
import { Box, Button, Container, Paper, Typography } from '@mui/material';

/**
 * Page qui permet d'ajouter une prélémvement automatique
 * @constructor
 */
export default function DirectDebitPage(): JSX.Element {
    //Params
    const { id } = useParams();
    //SnackBar pour les messages
    const showMessage = useSnackbars();
    const [sendForm, setSendForm] = useState(true);
    const [file, setFile] = useState<string>('');
    const [contentType, setContentType] = useState<string>('');
    const [fileName, setFileName] = useState<string>('');
    const [success, setSuccess] = useState(false);

    const location = useLocation();

    const isMensualise = location.state?.mensualise ?? false;

    //Navigate
    const navigate = useNavigate();

    //handler sur l'envoi du formulaire
    const handleSumbitForm = (form: DirectDebitFormDto) => {
        const token = localStorage.getItem('promotionMensualisationToken');
        const messageType = localStorage.getItem('messageType');
        setSendForm(false);
        const seven = 7;
        const data: DirectDebitDto = {
            titulaire: form.holder,
            bic: form.bic,
            iban: form.iban,
            membres: form.members,
            rib: file.substring(file.indexOf('base64,') + seven),
            email: form.email,
            tel: `0${form.tel}`,
            token: token ?? null,
            message: messageType ?? null,
        };
        if (id !== undefined) {
            if (isMensualise) {
                //Ajout du prélévement automatique
                changeDirectDebit(id, data)
                    .then(() => {
                        setSuccess(true);
                    })
                    .catch((error: Error | AxiosError) => {
                        showAxiosMessageError(error, showMessage);
                    })
                    .finally(() => {
                        setSendForm(true);
                    });
            } else {
                //Ajout du prélévement automatique
                createDirectDebit(id, data)
                    .then(() => {
                        setSuccess(true);
                        localStorage.removeItem('promotionMensualisationToken');
                        localStorage.removeItem('messageType');
                    })
                    .catch((error: Error | AxiosError) => {
                        showAxiosMessageError(error, showMessage);
                    })
                    .finally(() => {
                        setSendForm(true);
                    });
            }
        }
    };

    //handler sur le changement de valeur du input file
    const handleChangeFile = (event: any) => {
        const targetFile = event.target.files[0];
        setFileName(targetFile.name);
        setContentType(targetFile.type);
        convertToBase64(targetFile)
            .then((value: any) => {
                setFile(value);
            })
            .catch(() => {
                showMessage.errorAlert('Erreur lors du traitement du fichier.');
            });
    };

    /**
     * Méthode qui converti le fichier en base64
     * @param targetFile fichier
     */
    const convertToBase64 = (targetFile: any) => {
        return new Promise((resolve, reject) => {
            //Récupération du contenu de l'image
            const fileReader = new FileReader();
            fileReader.readAsDataURL(targetFile);

            //Définition dans le success
            fileReader.onload = () => {
                resolve(fileReader.result);
            };

            //Définition dans l'error
            fileReader.onerror = error => {
                reject(error);
            };
        });
    };
    // Dès qu'on récupère l'url de l'iframe, on l'affiche dans la page

    if (success) {
        return (
            <Container maxWidth="xl" sx={{ mt: { xs: 4, md: 15 } }}>
                <Paper sx={{ p: 4, borderRadius: 4, boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)' }}>
                    <Box sx={{ textAlign: 'center', mb: 4 }}>
                        <Typography variant="h5" fontWeight={800} color="primary.dark">
                            Succès
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            Vous allez recevoir d'ici quelques minutes un e-mail contenant un lien sécurisé pour
                            procéder à la <strong>signature électronique</strong> de votre contrat de mensualisation.
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            Pensez à vérifier vos courriers indésirables (spams) si le message ne s'affiche pas dans
                            votre boîte de réception d'ici peu.
                        </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center' }}>
                        <Button
                            onClick={() => {
                                navigate('/');
                            }}
                            variant="contained"
                        >
                            Retour à l'accueil
                        </Button>
                        <Button
                            onClick={() => {
                                navigate('/contrat/' + id);
                            }}
                            variant="contained"
                        >
                            Retour sur le contrat
                        </Button>
                    </Box>
                </Paper>
            </Container>
        );
    }

    return (
        <DirectDebitForm
            handleSumbitForm={handleSumbitForm}
            handleChangeFile={handleChangeFile}
            sendForm={sendForm}
            contentType={contentType}
            fileName={fileName}
            isMensualise={isMensualise}
        />
    );
}
